export enum FilterType {
  'Size' = 'size',
  'Color' = 'color',
  'Category' = 'category'
}

export interface Filter {
  name: string;
  code: FilterType | string;
  options: FilterOptions[];
}

export interface FilterOptions {
  id: string | number;
  name: string;
  image?: string;
  count?: number;
}
